export const OfficeBundleManagerState = {
	url: '/bundle-manager?system&profile&type&debug',
	title: 'Office Bundle Manager',
	template: '<office-bundle-manager></office-bundle-manager>',
	params: {
		system: {value: null, dynamic: true},
		profile: {value: null, dynamic: true},
		type: {value: null, dynamic: true},
		debug: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeBundleManagerPageMod" */
			'@Containers/office-bundle-manager-page/bundle-manager-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
